import React, { createContext, useState } from "react";

export const ContextBoard = createContext();

export const BoardProvider = ({ children }) => {
  // class 9 contexts
  const [candidateid, setCandidateid] = useState("");
  const [castecode, setCastecode] = useState("");
  const [divyangcode, setDivyangcode] = useState("");
  const [mode, setMode] = useState("");
  const [modeex, setModeex] = useState("");
  const [class9exregulardata, setClass9exregulardata] = useState("");
  const [RegistrationNumber, setRegistrationNumber] = useState("");
  const [sessionCode, setSessionCode] = useState("");

  // class 10 contexts
  const [candidateid10, setCandidateid10] = useState("");
  const [castecode10, setCastecode10] = useState("");
  const [divyangcode10, setDivyangcode10] = useState("");
  const [mode10, setMode10] = useState("");
  const [class10regulardata, setClass10regulardata] = useState(false);
  const [docverify, setDocverify] = useState(false);

  // Admin Edit School Details Start
  const [secondaryAdminSchoolCode, setSecondaryAdminSchoolCode] = useState("");
  const [intermediateAdminSchoolCode, setIntermediateAdminSchoolCode] =
    useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");

  // class 11 contexts

  const [class11candidateid, setClass11Candidateid] = useState("");
  const [class11castecode, setClass11Castecode] = useState("");
  const [class11divyangcode, setClass11Divyangcode] = useState("");
  //class 11 jac student
  const [class11mode, setClass11Mode] = useState("");
  const [class11jacstudent, setClass11JacStudent] = useState("");

  //class 11 other student

  const [class11othermode, setClass11OtherMode] = useState("");
  const [class11otherstudent, setClass11otherstudent] = useState("");

  //class 11 Ex-Regular student

  const [class11exregularmode, setClass11exregularmode] = useState("");
  const [class11exregulartudent, setClass11exregulartudent] = useState("");

  // class 11 before 2010

  const [class11before2010mode, setClass11before2010mode] = useState("");
  const [class11before2010, setClass11before2010] = useState("");

  // class 12 contexts

  const [candidateid12, setCandidateid12] = useState("");
  const [castecode12, setCastecode12] = useState("");
  const [divyangcode12, setDivyangcode12] = useState("");
  const [mode12, setMode12] = useState("");
  const [class12regulardata, setClass12regulardata] = useState(false);
  const [docverify12, setDocverify12] = useState(false);

  //
  const [permissions, setPermissions] = useState([]);

  return (
    <ContextBoard.Provider
      value={{
        class9exregulardata,
        setClass9exregulardata,
        mode,
        setMode,
        candidateid,
        setCandidateid,
        castecode,
        setCastecode,
        divyangcode,
        setDivyangcode,
        RegistrationNumber,
        setRegistrationNumber,
        sessionCode,
        setSessionCode,
        secondaryAdminSchoolCode,
        setSecondaryAdminSchoolCode,
        intermediateAdminSchoolCode,
        setIntermediateAdminSchoolCode,
        selectedDistrict,
        setSelectedDistrict,
        // class 11
        setClass11JacStudent,
        class11jacstudent,
        class11candidateid,
        setClass11Candidateid,
        class11castecode,
        setClass11Castecode,
        class11divyangcode,
        setClass11Divyangcode,
        class11mode,
        setClass11Mode,
        class11othermode,
        setClass11OtherMode,
        class11otherstudent,
        setClass11otherstudent,
        //
        class11exregularmode,
        setClass11exregularmode,
        class11exregulartudent,
        setClass11exregulartudent,
        // class11before2010,
        class11before2010mode,
        setClass11before2010mode,
        class11before2010,
        setClass11before2010,
        // class 10
        candidateid10,
        setCandidateid10,
        castecode10,
        setCastecode10,
        divyangcode10,
        setDivyangcode10,
        mode10,
        setMode10,
        class10regulardata,
        setClass10regulardata,
        setDocverify,
        docverify,
        // class 12
        candidateid12,
        setCandidateid12,
        castecode12,
        setCastecode12,
        divyangcode12,
        setDivyangcode12,
        mode12,
        setMode12,
        class12regulardata,
        setClass12regulardata,
        docverify12,
        setDocverify12,
        setModeex,
        modeex,
        //
        permissions,
        setPermissions,
      }}
    >
      {children}
    </ContextBoard.Provider>
  );
};
